import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Notifications = forwardRef((props, ref) => {
	const [state, setState] = useState();
	let item = [];
	const putItems = (value) => {
		console.log("putItems value=", value);
		value
			.sort((x, y) =>
				new Date(x.createDate) < new Date(y.createDate) ? 1 : -1
			)
			.map((x) => {
				let id = x.id;
				let key = x.key;

				let createDate = x.createDate;
				let readstatus = x.readstatus;
				let readstatusDate = x.readstatusDate;

				let username = x.username;
				let message = x.message;
				let photo = x.photo;
				if (key)
					try {
						item.push(
							<Link to={"/DocDetail/" + id} key={key}>
								<div className="notifications__item">
									<div className="notifications__item__avatar">
										<img src={photo} />
									</div>

									<div className="notifications__item__content">
										<span className="notifications__item__title">
											{username}
										</span>
										<span className="notifications__item__message">
											{message}
										</span>
										<span className="notifications__item__message">
											at {createDate}
										</span>
									</div>

									<div>
										<div className="notifications__item__option archive js-option">
											<i className="fas fa-folder"></i>
										</div>
										<div className="notifications__item__option delete js-option">
											<i className="fas fa-trash"></i>
										</div>
									</div>
								</div>
							</Link>
						);
					} catch (e) {}
			});
		setState(item);
	};
	try {
		if (false)
			props.item.map((x) => {
				let id = x.id;
				let key = x.key;

				let createDate = x.createDate;
				let readstatus = x.readstatus;
				let readstatusDate = x.readstatusDate;

				let username = x.username;
				let message = x.message;
				let photo = x.photo;
				if (key)
					item.push(
						<div className="notifications__item" key={key}>
							<div className="notifications__item__avatar">
								<img src={photo} />
							</div>

							<div className="notifications__item__content">
								<span className="notifications__item__title">{username}</span>
								<span className="notifications__item__message">{message}</span>
								<span className="notifications__item__message">
									at {createDate}
								</span>
							</div>

							<div>
								<div className="notifications__item__option archive js-option">
									<i className="fas fa-folder"></i>
								</div>
								<div className="notifications__item__option delete js-option">
									<i className="fas fa-trash"></i>
								</div>
							</div>
						</div>
					);
			});
	} catch (e) {}

	useImperativeHandle(ref, () => {
		return { putItems: (value) => putItems(value) };
	});

	console.log("Items to print=", item);

	return (
		<div className="wrappernotification">
			<div className="notifications">{state}</div>
		</div>
	);
});

export default Notifications;
